<template>
  <el-dialog
    title="编辑得分"
    :visible.sync="$visible"
    width="480px"
    :show-close="false"
    @close="scoreCancel">
    <el-form
      ref="scoreForm"
      :model="$scoreForm"
      :rules="rules"
      size="small"
      label-position="left"
      label-width="110px">
      <el-form-item
        label="服务质量"
        prop="serviceQuality">
        <el-input
          v-model.trim="$scoreForm.serviceQuality"
          placeholder="请输入打分，范围为0-10，小数点后保留一位">
        </el-input>
      </el-form-item>
      <el-form-item
        label="服务效果"
        prop="serviceEffect">
        <el-input
          v-model.trim="$scoreForm.serviceEffect"
          placeholder="请输入打分，范围为0-10，小数点后保留一位">
        </el-input>
      </el-form-item>
      <el-form-item
        label="服务态度"
        prop="serviceAttitude">
        <el-input
          v-model.trim="$scoreForm.serviceAttitude"
          placeholder="请输入打分，范围为0-10，小数点后保留一位">
        </el-input>
      </el-form-item>
      <el-form-item
        label="平台打分"
        prop="platformScore">
        <el-input
          v-model.trim="$scoreForm.platformScore"
          placeholder="请输入打分，范围为0-10，小数点后保留一位">
        </el-input>
      </el-form-item>
      <el-form-item
        label="身份真实"
        prop="infoScore">
        <el-input
          v-model.trim="$scoreForm.infoScore"
          placeholder="请输入打分，范围为0-10，小数点后保留一位">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button
        size="small"
        @click="scoreCancel">
        取消
      </el-button>
      <el-button
        type="primary"
        size="small"
        :loading="scoreBtnLoading"
        @click="scoreConfirm">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as api from '@/api'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    scoreForm: Object,
    orgId: {
      type: String,
      default: ''
    }
  },
  data () {
    const emptyValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('打分不能为空'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        serviceQuality: [
          { validator: emptyValidator, trigger: ['blur', 'change'] },
          { pattern: /^([0-9]{1}\.[0-9]{1}|[0-9]{1}|10)$/, message: '服务质量应为0-10的一位小数', trigger: ['blur', 'change'] }
        ],
        serviceEffect: [
          { validator: emptyValidator, trigger: ['blur', 'change'] },
          { pattern: /^([0-9]{1}\.[0-9]{1}|[0-9]{1}|10)$/, message: '服务效果应为0-10的一位小数', trigger: ['blur', 'change'] }
        ],
        serviceAttitude: [
          { validator: emptyValidator, trigger: ['blur', 'change'] },
          { pattern: /^([0-9]{1}\.[0-9]{1}|[0-9]{1}|10)$/, message: '服务态度应为0-10的一位小数', trigger: ['blur', 'change'] }
        ],
        platformScore: [
          { validator: emptyValidator, trigger: ['blur', 'change'] },
          { pattern: /^([0-9]{1}\.[0-9]{1}|[0-9]{1}|10)$/, message: '平台打分应为0-10的一位小数', trigger: ['blur', 'change'] }
        ],
        infoScore: [
          { validator: emptyValidator, trigger: ['blur', 'change'] },
          { pattern: /^([0-9]{1}\.[0-9]{1}|[0-9]{1}|10)$/, message: '身份真实应为0-10的一位小数', trigger: ['blur', 'change'] }
        ]
      },
      scoreBtnLoading: false
    }
  },
  computed: {
    $visible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    },
    $scoreForm: {
      get () {
        return this.scoreForm
      },
      set (val) {
        this.$emit('update:scoreForm', val)
      }
    }
  },
  methods: {
    scoreCancel () {
      this.$refs.scoreForm.resetFields()
      this.$visible = false
    },
    scoreConfirm () {
      this.$refs.scoreForm.validate(valid => {
        if (valid) {
          this.scoreBtnLoading = true
          api.editPlatformScore(this.orgId, {
            ...this.$scoreForm
          }).then(res => {
            if (res.data.code === 0) {
              this.$message.success('操作成功')
              this.$emit('confirm')
              this.$visible = false
            } else {
              this.$message.error(res.data.message)
            }
          }).catch(err => {
            this.$message.error('请求出错')
            console.log(err)
          }).finally(() => {
            this.scoreBtnLoading = false
          })
        } else {
          console.log('error submit')
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
